const getClassName = (className, isResto) =>
  `${className}${isResto ? 'Resto' : ''}`;

export default getClassName;
